import React from 'react';
import { PropsWithChildren } from 'react';
import { EggCountdownProvider, EggStageProvider } from './EggStageContext';
import { AccountProvider } from './AccountContext';
import { EggBreakerPairProvider } from './EggBreakerPairContext';
import { QueryClientProvider } from 'react-query';
import { queryClient } from './QueryClient';
import { SkeletonTheme } from 'react-loading-skeleton';

export function GlobalContext({ children }: PropsWithChildren<{}>) {
  return (
    <SkeletonTheme baseColor="var(--gray-9)" highlightColor="var(--gray-8)">
      <QueryClientProvider client={queryClient}>
        <AccountProvider>
          <EggCountdownProvider>
            <EggStageProvider>
              <EggBreakerPairProvider>{children}</EggBreakerPairProvider>
            </EggStageProvider>
          </EggCountdownProvider>
        </AccountProvider>
      </QueryClientProvider>
    </SkeletonTheme>
  );
}
